import { TenantEntity } from '../TenantEntity'

export class ScenarioSettings extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get name() {
    return this._data.name
  }
  set name(name) {
    this._data.name = name
  }
  get dataScript() {
    return this._data.dataScript
  }
  set dataScript(dataScript) {
    this._data.dataScript = dataScript
  }
  get dataMessage() {
    return this._data.dataMessage
  }
  set dataMessage(dataMessage) {
    this._data.dataMessage = dataMessage
  }
  get propertiesData() {
    return this._data.propertiesData
  }
  set propertiesData(propertiesData) {
    this._data.propertiesData = propertiesData
  }
  get automationConfigUuid() {
    return this._data.automationConfigUuid
  }
  set automationConfigUuid(automationConfigUuid) {
    this._data.automationConfigUuid = automationConfigUuid
  }
}
